import useMetadataStore from "@/store/metadata.store";

export default function About({ helperCls }: { helperCls: string }) {
  const { data } = useMetadataStore();

  return (
    <>
      <section
        id="about-1"
        className={`bg-fixed wide-100 about-section division ${
          helperCls ? helperCls : ""
        }`}
      >
        <div className="container">
          <div className="row">
            {/* ABOUT TEXT */}
            <div className="col-xl-10 offset-xl-1">
              <div className="about-1-txt text-center">
                {/* Title */}
                <h2>
                  <span className="yellow-color" role="presentation">
                    Our Story!
                  </span>
                </h2>
                {/* Text */}
                <p className="p-xl grey-color" style={{ textAlign: "left" }}>
                  {data?.customer?.oosConfig?.aboutUs?.description}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
